import { app_emptylayout_children } from "dependencies/emptyLayout/index.js"
export default {
  name: "布局",
  id: "",
  type: "emptyLayoutComponent",
  children: app_emptylayout_children,
  enable: params => params.admin
}
